import { render, staticRenderFns } from "./outdoorlight.vue?vue&type=template&id=5fc151f6&scoped=true&"
import script from "./outdoorlight.js?vue&type=script&lang=js&"
export * from "./outdoorlight.js?vue&type=script&lang=js&"
import style0 from "./outdoorlight.css?vue&type=style&index=0&id=5fc151f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fc151f6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
